import abi from './Transaction.json'

export const contractABI = abi.abi
export const contractAddress = '0x5f0b39FE628b2665C2A58B16B6975f2Be7De8F62'